import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';
import * as actions from '../redux.actions';
import * as selectors from '../redux.selectors';

const DeleteConfirmationDialog = () => {
    const dispatch = useDispatch();
    const dialog = useSelector(selectors.selectDeleteDialog);
    const loading = useSelector(selectors.selectLoading);

    const handleConfirm = () => {
        if (dialog.template) {
            dispatch(actions.deleteTemplate(dialog.template.id));
        }
    };

    const handleClose = () => {
        dispatch(actions.closeDeleteDialog());
    };

    return (
        <Dialog
            open={dialog.open}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to delete the template "
                    <strong>{dialog.template?.name}</strong>"? This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={handleClose} sx={{ textTransform: 'none' }}>
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="error"
                    disabled={loading}
                    sx={{ textTransform: 'none' }}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;
